export enum EventActions {
  click = 'click',
}

export enum EventNames {
  WellBeingDashboard = 'wellbeing_dashboard',
  LoginScreen = 'login_screen',
}

export enum EventCategories {
  GenerateReport = 'generate_report',
  submitFeedback = 'submit_feedback',
}
